import React from "react";

export default function LoginButton() {
  return (
    <button
      className="underline underline-offset-4"
      onClick={() => {
        // Functions are not a client-side route, so we hit the server-side route to login.
        window.location.assign("/api/login");
      }}
    >
     Login
    </button>
  );
}
